import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'reactstrap';
import { useHistory } from 'react-router';
import queryString from 'query-string';
import FilterBox from './filter';
import * as InformationAction from 'store/actions/information';
import * as CollectionAction from 'store/actions/collection';
import * as depositInvoiceTransaction from 'services/depositInvoiceTransaction';
import List from './list';
import { getHeaders } from './header';
import { t } from 'i18next';
import useViewPermission from 'hooks/useViewPermission';
import { NotificationManager } from 'react-notifications';

function CustomInvoiceTransaction() {
  const dispatch = useDispatch();
  const router = useHistory();
  const [data, setData] = React.useState({ docs: [], totalDocs: 0 });
  const [searchValue, setSearchValue] = React.useState(null);
  const [actionLoading, setActionLoading] = React.useState(false);
  const { isOwn, isBranch } = useViewPermission('document');

  React.useEffect(() => {
    dispatch(InformationAction.getBranch());
    dispatch(CollectionAction.getAll({}));
  }, [dispatch]);

  React.useEffect(() => {
    loadData();
  }, [router.location.search]);

  const loadData = async (value = null) => {
    setSearchValue(value);
    let query = { limit: 10, page: 1 };
    if (router.location.search) query = queryString.parse(router.location.search);

    if (value) {
      query = { limit: 10, page: 1 };
    }

    if (isOwn()) query.isOwn = !!isOwn();
    if (isBranch()) query.isBranch = !!isBranch();

    const body = value ? value : searchValue ? searchValue : {};

    const response = await depositInvoiceTransaction.getAll({ ...query, ...body });
    if (response) {
      setData(response);
    }
  };

  const handleExportData = async () => {
    setActionLoading(true);
    let query = {};

    if (searchValue) {
      query = searchValue;
    }

    if (isOwn()) query.isOwn = !!isOwn();
    if (isBranch()) query.isBranch = !!isBranch();
    
    const response = await depositInvoiceTransaction.exportData(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `deposit_invoice_transaction_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    setActionLoading(false);
  };

  return (
    <>
      <List
        headers={getHeaders()}
        data={data}
        onInvoiceClick={(e) => {
          // Navigate to invoice detail or show detail dialog
          console.log('Invoice clicked:', e);
        }}
        filter={
          <FilterBox
            onSearch={(value) => {
              loadData(value);
            }}
          />
        }
        buttons={
          <>
            <Button
              style={{ width: 100 }}
              size='sm'
              onClick={() => {
                loadData({});
                router.push('/invoice/deposit-invoice-transaction');
              }}
            >
              <i className='fa fa-spinner mr-2' /> {t('refresh')}
            </Button>
            <Button 
              style={{ width: 100 }} 
              size='sm' 
              disabled={actionLoading} 
              onClick={() => handleExportData()}
            >
              {actionLoading ? <i className='fa fa-spinner mr-2' /> : <i className='fa fa-file-excel mr-2' />}
              {t('export')}
            </Button>
          </>
        }
      />
    </>
  );
}

export default CustomInvoiceTransaction;
